export const keys = {
  //Fully Prod
   ServicePath: "https://api.aranyasetu.org",
   ServiceIP: "https://api.aranyasetu.org",
   authorizedURL: "http://erp.vkpatelgroup.com",

  // Local 
    // ServicePath: "http://localhost:5002",
    // ServiceIP: "http://localhost:5002",
    // authorizedURL: "http://localhost:3000",

  // //QA 
  // ServicePath: "https://treemetricapiv2.imageio.in",
  // ServiceIP: "https://treemetricapiv2.imageio.in",
  // authorizedURL: "https://treemetricv2.imageio.in",


    REACT_APP_GA_TRACKING_ID:"G-97711QKT5F"
};



